<template>
  <div class="camera_page">
    <div class="camera_content">
      <div class="code_close" @click="close()">
        <img src="@/assets/img/left-arrow.svg" />
      </div>
      <div
        class="loop_line"
        :style="{ display: !isSuccessful ? 'block' : 'none' }"
      ></div>
      <div class="video_nav">
        <video id="video" class="video" autoplay :controls="false"></video>
      </div>
    </div>
    <div class="point" :style="{ display: isSuccessful ? 'block' : 'none' }">
      <img src="@/assets/img/loading.svg" alt="" />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { throttle } from "lodash-es";
import { BrowserMultiFormatReader } from "@zxing/library";
// import VCconsole from "vconsole";
export default {
  name: "scanCodePage",
  data() {
    return {
      isSuccessful: false, // 是否扫描成功，防止无限次扫描
      scanTextData: {
        codeReader: null,
        tipMsg: "识别二维码",
        // 这个，就是当前调用的摄像头的索引，为什么是6，我会在后面说的 华为手机是鸿蒙系统有8个摄像头
        num: 5,
        // 这个就是扫描到的摄像头的数量
        videoLength: "",
      },
      hasBind: false,
    };
  },
  mounted() {
    // new VCconsole();
    this.scanTextData.codeReader = new BrowserMultiFormatReader();
    this.openScan(); // 打开摄像头
  },
  methods: {
    ...mapMutations("scanStore", ["setScannedCode"]),
    // 返回
    close() {
      this.$router.go(-1);
    },
    // 暂时没用到
    async setCameraResolution(constraints, deviceId) {
      constraints.video = {
        ...constraints.video,
        deviceId: { exact: deviceId },
        width: 1280,
        height: 720,
        // 添加额外的设置
        focus: { mode: "continuous" }, // 连续对焦
        exposureMode: "continuous", // 连续曝光
        exposureTime: 50, // 曝光时间
      };
      return constraints;
    },
    async openScan() {
      console.log("openScan");
      try {
        const videoInputDevices = await this.scanTextData.codeReader.getVideoInputDevices();
        if (!videoInputDevices.length) {
          this.$message.warning("没有获取到摄像头");
          return;
        }
        // 默认获取第一个摄像头设备id
        let deviceId = videoInputDevices[0].deviceId;

        console.log("摄像头列表", videoInputDevices.length, videoInputDevices );

        const videoInputDevicesLabelStr = JSON.stringify(
          videoInputDevices[0].label
        );

        console.log(videoInputDevicesLabelStr, "videoInputDevicesLabelStr");

        if (videoInputDevices.length > 1) {
          // 这里主要兼容华为手机，华为会获取到5个以上摄像头，最后一个摄像头最清晰
          if (videoInputDevices.length >= 5) {
            deviceId = videoInputDevices[videoInputDevices.length - 1].deviceId;
          } else {
            // 如果不是华为手机，并且
            if (videoInputDevicesLabelStr.indexOf("back") > -1) {
              deviceId = videoInputDevices[0].deviceId;
            } else {
              deviceId = videoInputDevices[1].deviceId;
            }
          }
        }
        // 浏览器设置不生效
        // const mediaConstraints = await this.setCameraResolution({ video: true }, deviceId);
        await this.decodeFromInputVideoFunc(deviceId);
      } catch (error) {}
    },
    async decodeFromInputVideoFunc(deviceId) {
      try {
        this.scanTextData.codeReader.reset();
        this.scanTextData.codeReader.decodeFromVideoDevice(deviceId, "video", (result, err) => {
          if (result && result.text) {
            this.isSuccessful = true;
            this.handleResult(result.text);
          }
          if (err && !err) {
            this.$message.open({ content: `扫描失败，${err}`, type: "error", duration: 1 });
          }
        })
      } catch (error) {
        this.$message.open({ content: `扫描失败，${error}`, type: "error", duration: 1 });
      }
    },
    handleResult: throttle(
      function (scanResult) {
        console.log("扫描成功", scanResult);
        this.isSuccessful = false;
        this.setScannedCode(scanResult);
        this.close();
      },
      800,
      { leading: false }
    ),
  },
  // 关闭组件时自动重置
  destroyed() {
    this.scanTextData.codeReader.reset(); // 重置摄像头
  },
};
</script>

<style lang="less" scoped>
.camera_page {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  background-size: 3rem 3rem;
  background-position: -1rem -1rem;
  overflow: hidden;
}
.camera_content {
  height: 100%;
  width: 100%;
  position: relative;
}
.code_close {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 30px;
  top: 30px;
  z-index: 999999;
}
.code_close > img {
  height: 100%;
  width: 100%;
  display: block;
}
.loop_line {
  height: 3px;
  width: 80%;
  background-color: #009be9;
  border-radius: 50%;
  box-shadow: 1px -4px 25px 7px rgba(0, 155, 233, 0.5);
  position: absolute;
  left: 50%;
  top: 20%;
  transform: translateX(-50%);
  animation: myfirst 3s linear infinite;
  z-index: 999999;
}
@keyframes myfirst {
  0% {
    top: 20%;
  }
  100% {
    top: 80%;
  }
}
.video_nav {
  height: 100%;
  width: 100%;
}
#video {
  height: 100vh;
  width: 100vw;
  object-fit: cover;
}

.point {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  display: flex; /* 添加flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  text-align: center;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 4px;
  box-sizing: border-box;
}

.point img {
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: loading 1.5s linear infinite;
}

@keyframes loading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
